import { Component, OnInit, OnChanges, SimpleChanges, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, FormBuilder } from '@angular/forms';

import { DeviceDetectorService } from 'ngx-device-detector';
import { DialogPaformComponent, IDataPaymentAuthorizationForm } from '../dialog/dialog-paform.component';
import { DialogPafWarnComponent } from '../dialog/dialog-paform-warn.component';
import { DialogPermitComponent, IDataPermitDialog } from '../dialog/dialog-permit.component';
import { DialogUploadComponent, DialogUploadData } from '../dialog/dialog-upload.component';

import { MatSnackBar } from '@angular/material/snack-bar';
import { AppSheetHelpComponent } from '../../chrome/app-sheet-help.component';
import { blobToBase64String } from 'blob-util';

import {
  AuthenticationService,
  ApplicationApiService,
  ApplicationPaymentApiService,
  ApprovalTaskItemApiService,
  ContactApiService,
  ApplicationEventApiService,
  AnnotationApiService
  } from '../../data-services/index';

import {
  IApplication, IApplicationInput, IApplicationEventInput,
  IApplicationPayment, IApplicationPaymentInput,
  IApprovalTask, IApprovalTaskItem, IApprovalTaskItemInput,
  IHelp, HelpApiService, IOptionSets, IUser, IContact, IOptions, IAnnotationInput,
  IApplicationSubmitInput,
  IAdditionalTaskItem,
  IAdditionalOptions
} from '@ebb-v2/ebb-integration';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { MatDialog } from '@angular/material/dialog';
import { cloneDeep } from '@apollo/client/utilities';

@Component({
    selector: 'ebb-portal-postretrofit',
    templateUrl: './postretrofit.component.html',
    standalone: false
})
export class PostretrofitComponent implements OnInit, OnChanges {
  @Input('application') application: IApplication;
  @Input('listHelp') listHelp: IHelp[];
  @Input('listAdditionalTaskItem') listAdditionalTaskItem: IAdditionalTaskItem[];
  @Input('listOptionSets') listOptionSets: IOptionSets[];
  @Output() emitEventContractorChange = new EventEmitter<IApplicationInput>();
  @Output() emitFileChangeEvent = new EventEmitter<IApprovalTask>();
  @Output() emitDataFormChangeEvent = new EventEmitter<IApprovalTask>();
  @Output() emitReceiptFormChangeEvent = new EventEmitter<IApplicationInput>();
  @Output() emitSubmitApplication = new EventEmitter<IApplicationSubmitInput>();

  public currentUser: IUser;

  // Application Data
  public applicationOwner: IContact = null;
  public applicationContractor: IContact = null;
  public applicationPayment: IApplicationPayment = {} as IApplicationPayment;

  // Approval Task Data
  public taskHousePhotos: IApprovalTask;
  public taskHeaterPhotos: IApprovalTask;
  public taskCrawlspacePhotos: IApprovalTask;
  public taskReceipts: IApprovalTask;
  public waitingForReceiptInfo = true;
  public receiptsEngineeredTypeOptions: IOptions[] = {} as IOptions[];
  public receiptsRetrofitTypeOptions: IOptions[] = {} as IOptions[];
  public additionalPermitOptions: IAdditionalOptions[]  = [];
  public taskPaymentAuthorization: IApprovalTask;
  public authorizedPaymentId = '';
  public authorizedPaymentTo = '';
  public authorizedPaymentSubmitted = false;
  public pendingPafUpdate = false;

  public programHasHousePhotos = false;

  public taskPermitSignoff: IApprovalTask;
  public addPermitInfo: FormGroup;
  public waitingForPermitInfo = true;
  public showAddAnother = true;

  public viewApprovalTask = 0;
  public progressSaveOptionalPermitDoc = false;
  public isreadonly = false;
  public readonly stageCode: number = 700000001;

  constructor(
    private fb: FormBuilder,
    private readonly deviceService: DeviceDetectorService,
    private readonly authenticationService: AuthenticationService,
    private readonly apiApplication: ApplicationApiService,
    private readonly apiApplicationEvent: ApplicationEventApiService,
    private readonly apiApplicationPayment: ApplicationPaymentApiService,
    private readonly apiApprovalTaskItem: ApprovalTaskItemApiService,
    private readonly apiAnnotation: AnnotationApiService,
    private readonly apiContact: ContactApiService,
    private readonly dialogPaf: MatDialog,
    private readonly dialogPafWarn: MatDialog,
    private readonly dialogPermit: MatDialog,
    private readonly dialogSubmit: MatDialog,
    private readonly dialogConfirmSubmit: MatDialog,
    private readonly dialogUpload: MatDialog,
    private readonly infoSheet: MatBottomSheet,
    private readonly apiHelp: HelpApiService,
    private readonly router: Router,
    private readonly snackBar: MatSnackBar,
  ) { }

  ngOnInit() {
    this.currentUser = this.authenticationService.currentUserValue;
    this.checkFormData();
    this.getOwnerContactInfo();
    this.getContractorContactInfo();
    this.refreshData(true);

    if (this.application.stateCode === 1) {
      this.isreadonly = true;
    }

    this.addPermitInfo = this.fb.group({
      permitType: []
    });
    var listPermit = this.listAdditionalTaskItem.filter(x=>x.stageCode== 700000001 && x.programTypeCode== this.application.programType);
listPermit.forEach(taskItemName=>{

  this.additionalPermitOptions.push({label:taskItemName.name,value:taskItemName.name});
});
  }

  ngOnChanges( changes: SimpleChanges ) {
    this.checkFormData();
    this.getContractorContactInfo();
    this.getApplicationPaymentId();
    this.loadApprovalTaskData();
    this.focusApprovalTask(false);
    setTimeout(() => this.checkIfReadyForSubmission(changes));
  }

  private refreshData(initialLoad:boolean): void {
    this.getApplicationPaymentId();
    this.loadApprovalTaskData();
    this.focusApprovalTask(initialLoad);
    const indexRetrofitOptions = this.listOptionSets.findIndex(i => i.name === 'cea_retrofittype');
    this.receiptsRetrofitTypeOptions = [...this.listOptionSets[indexRetrofitOptions].options];
    const indexEngineeredOptions = this.listOptionSets.findIndex(i => i.name === 'cea_isengineeredsolution');
    this.receiptsEngineeredTypeOptions = [...this.listOptionSets[indexEngineeredOptions].options];
  }

  private getApplicationPaymentId(): void {
    if(this.isHomeowner() && this.application !== undefined){
    this.apiApplicationPayment
      .getApplicationPayment(this.application.id)
      .subscribe(
        _data => {
          var data = cloneDeep(_data);
          if (data) {
            this.authorizedPaymentId = data.id;
            this.applicationPayment = data;
            if (this.application.paymentDataSubmitted) {
              this.authorizedPaymentTo = data.pafFullName;
              this.authorizedPaymentSubmitted = true;
            }
          }
        },
        err => console.warn(`PreRetrofit.checkFormData() - ${err}`)
      );
  }}

  /**********************************************
   * Owner
   */

  private getOwnerContactInfo(): void {
    this.getContact(this.application._Ebb_OwnerId, 700000000);
  }

  private getContractorContactInfo(): void {
    this.getContact(this.application._Ebb_ContractorId, 700000001);
  }

  private getContact(currentId: string, typeCode: number): void {
    this.apiContact
      .getContact(currentId)
      .subscribe(
        _data => {
          var data = cloneDeep(_data);
          if (typeCode === 700000000) {
            this.applicationOwner = data;
          }
          if (typeCode === 700000001) {
            this.applicationContractor = data;
          }
        },
        error => console.warn(`ERROR: UserAccount.getContact() - ${error}`)
      )
  }

  /**********************************************
   * Form Data
   */
  private checkFormData(): void {
    if (this.application.retrofitConstructionNumberOfDays <= 0) {
      this.waitingForPermitInfo = true;
    } else {
      this.waitingForPermitInfo = false;
    }
    if (this.application.retrofitType !== null) {
      this.waitingForReceiptInfo = false;
    }
  }

  /**********************************************
   * Building permit info
   */
  public onshowBuildingPermitInfo(): void {
    const dataDialog: IDataPermitDialog = {} as IDataPermitDialog;
    dataDialog.permitIssuer = this.application.permitIssuer;
    dataDialog.permitIssuedDate = this.application.permitIssuedDate;
    dataDialog.permitPlanType = this.application.permitPlanCodeOptionSet;
    dataDialog.permitNumber = this.application.permitNumber;

    const dialogRef = this.dialogPermit.open(DialogPermitComponent, {
      width: '300px',
      data: dataDialog
    });
  }

  /**********************************************
   * Payment Authorization
   */

  public onClickSubmitPaymentAuthorization(): void {
    const dataDialog: IDataPaymentAuthorizationForm = {} as IDataPaymentAuthorizationForm;
    console.log(`Payment ID: ${this.authorizedPaymentId}`);
    dataDialog.applicationPayment = this.applicationPayment;
    dataDialog.applicationOwner = this.applicationOwner;
    dataDialog.applicationContractor = this.applicationContractor;
    dataDialog.applicationDweling = this.application.dwelling;
    dataDialog.programType = this.application.programType;
    const dialogRef = this.dialogPaf.open(DialogPaformComponent, {
      width: '400px',
      data: dataDialog
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        const applicationPaymentInput: IApplicationPaymentInput = {} as IApplicationPaymentInput;
        applicationPaymentInput._Ebb_ApplicationId = this.application.id;
        applicationPaymentInput.pafTypeCode = dataDialog.pafTypeCode;
        this.applicationPayment.pafTypeCode = dataDialog.pafTypeCode;
        applicationPaymentInput.pafFullName = dataDialog.pafFullName;
        this.applicationPayment.pafFullName = dataDialog.pafFullName;
        applicationPaymentInput.pafAddressStreet = dataDialog.pafAddressStreet;
        applicationPaymentInput.pafAddressCity = dataDialog.pafAddressCity;
        applicationPaymentInput.pafAddressState = dataDialog.pafAddressState;
        applicationPaymentInput.pafAddressZip = dataDialog.pafAddressZip;
        applicationPaymentInput.pafAuthorizationDate = dataDialog.pafAuthorizationDate;
        applicationPaymentInput.pafPaymentTypeCode = dataDialog.pafPaymentTypeCode;
        this.applicationPayment.pafPaymentTypeCode = dataDialog.pafPaymentTypeCode;
        applicationPaymentInput._Ebb_AchPaymentId = dataDialog._Ebb_AchPaymentId;
        this.applicationPayment._Ebb_AchPaymentId = dataDialog._Ebb_AchPaymentId;
        this.authorizedPaymentTo = dataDialog.pafFullName;
        this.authorizedPaymentSubmitted = true;
        this.apiApplicationPayment
        .updateApplicationPayment(applicationPaymentInput, this.authorizedPaymentId)
        .subscribe(
          data => {
         
            this.authorizedPaymentId =  cloneDeep(data);
            const applicationInput: IApplicationInput = {} as IApplicationInput;
            applicationInput.paymentDataSubmitted = true;
            this.apiApplication
              .updateApplication(applicationInput, this.application.id)
              .subscribe(
                () => {
                  this.updateDataTaskItem(this.taskPaymentAuthorization, this.authorizedPaymentId, false);
                },
                error => console.warn(`Error: onClickSubmitPaymentData() - ${error}`)
              );
          },
          err => console.warn(`onClickSubmitPaymentData() - ${err}`)
        );
      }
    });
  }

  private updatePaymentAuthorization(): void {
    const applicationPaymentInput: IApplicationPaymentInput = {} as IApplicationPaymentInput;
    applicationPaymentInput._Ebb_ApplicationId = this.application.id;
    applicationPaymentInput.pafTypeCode = 700000001;
    this.applicationPayment.pafTypeCode = 700000001;
    applicationPaymentInput.pafFullName = '';
    this.applicationPayment.pafFullName = '';
    applicationPaymentInput.pafAddressStreet = '';
    applicationPaymentInput.pafAddressCity = '';
    applicationPaymentInput.pafAddressState = '';
    applicationPaymentInput.pafAddressZip = '';
    applicationPaymentInput.pafAuthorizationDate = null;
    this.authorizedPaymentTo = '';
    this.authorizedPaymentSubmitted = false;
    this.apiApplicationPayment
    .updateApplicationPayment(applicationPaymentInput, this.authorizedPaymentId)
    .subscribe(
      data => {
        this.authorizedPaymentId = cloneDeep(data);;
        const applicationInput: IApplicationInput = {} as IApplicationInput;
        applicationInput.paymentDataSubmitted = false;
        this.apiApplication
          .updateApplication(applicationInput, this.application.id)
          .subscribe(
            () => {
              this.taskPaymentAuthorization.statusCode = 700000000;
              this.updateDataTaskItem(this.taskPaymentAuthorization, this.authorizedPaymentId, true);
            },
            error => {
              console.warn(`Error: updatePaymentAuthorization() - ${error}`);
              this.pendingPafUpdate = false;
            }
          );
      },
      err => {
        console.warn(`updatePaymentAuthorization() - ${err}`);
        this.pendingPafUpdate = false;
      }
    );
  }

  private updateDataTaskItem(task: IApprovalTask, payloadName: string, pending: boolean): void {
    const approvalTaskItem: IApprovalTaskItemInput = {} as IApprovalTaskItemInput;
    const nowDate: Date = new Date();
    const taskItem: IApprovalTaskItem = task.approvalTaskItems[0];
    approvalTaskItem.id = taskItem.id;
    approvalTaskItem.payloadName = payloadName;
    approvalTaskItem.submitDate = nowDate;
    if (pending) {
      //700000000=Pending
      approvalTaskItem.statusCode = 700000000;
    } else {
        //700000003=Updated
        if (taskItem.statusCode !== 700000003) {
        approvalTaskItem.statusCode = 700000003;
      }
    }

    this.apiApprovalTaskItem
    .saveItem(approvalTaskItem, this.application.id, null)
    .subscribe(
      data => {
        if (task.statusCode !== 700000003 ) {
          task.statusCode = 700000003;
        }
        this.onEmitDataFormUpdate(task);
        if (pending) {
          this.application.eventApplicationSubmitted = false;
          this.onEmitSubmitApplication(false);
          const dialogRef = this.dialogPafWarn.open(DialogPafWarnComponent, {
            width: '400px'
          });
        }
        this.pendingPafUpdate = false;
      },
      err => {
        console.warn(`PostretrofitComponent.updateDataTaskItem() - ${err}`);
        this.pendingPafUpdate = false;
      }
    );
  }

  private updateTimeSpanTaskItems(task: IApprovalTask): void {
    const taskItemConstruction1: IApprovalTaskItem = task.approvalTaskItems.find(x => x.name === 'Construction');
    const taskItemConstruction2: IApprovalTaskItem = task.approvalTaskItems.find(x => x.name === 'Construction Time Span');
    const taskItemConstruction: IApprovalTaskItem = taskItemConstruction2 !== undefined ? taskItemConstruction2 : taskItemConstruction1;
    const taskItemInspection: IApprovalTaskItem = task.approvalTaskItems.find(x => x.name === 'Inspection');
    const nowDate: Date = new Date();
    const taskItem: IApprovalTaskItemInput = {} as IApprovalTaskItemInput;
    taskItem.submitDate = nowDate;
    taskItem.statusCode = 700000003; //Updated

    if (taskItemConstruction && taskItemConstruction.payloadName === 'dirty' && taskItemInspection && taskItemInspection.payloadName === 'dirty') {
      this.updateTimeSpanTaskItemsBoth(task, taskItem, taskItemConstruction.id, taskItemInspection.id);
    } else if (taskItemConstruction && taskItemConstruction.payloadName === 'dirty') {
      this.updateTimeSpanTaskItemsOne(task, taskItem, taskItemConstruction.id);
    } else if (taskItemInspection && taskItemInspection.payloadName === 'dirty') {
      this.updateTimeSpanTaskItemsOne(task, taskItem, taskItemInspection.id);
    } else {
      this.updateTimeSpanTaskItemsBoth(task, taskItem, '', '');
    }
  }

  private updateTimeSpanTaskItemsBoth(task: IApprovalTask, taskItem: IApprovalTaskItemInput, constructionId: string, inspectionId: string): void {

    if (constructionId === '') {
      taskItem.typeCode = 700000000;
      taskItem.name = 'Construction Time Span';
      taskItem.payloadTypeCode = 700000001;
    } else {
      taskItem.id = constructionId;
    }

    this.apiApprovalTaskItem
    .saveItem(taskItem, this.application.id, task.id)
    .subscribe(
      data => {

        if (inspectionId === '') {
          taskItem.typeCode = 700000000;
          taskItem.name = 'Inspection';
          taskItem.payloadTypeCode = 700000001;
        } else {
          taskItem.id = inspectionId;
        }

        this.apiApprovalTaskItem
        .saveItem(taskItem, this.application.id, task.id)
        .subscribe(
          rtn => {
          },
          er => {
            console.warn(`PostretrofitComponent.updateTimeSpanTaskItemsBoth('Inspection') - ${er}`);
          },
          () => {
            this.emitDataFormChangeEvent.emit(task);
          }
        );
      },
      err => {
        console.warn(`PostretrofitComponent.updateTimeSpanTaskItemsBoth('Construction') - ${err}`);
      }
    );
  }

  private updateTimeSpanTaskItemsOne(task: IApprovalTask, taskItem: IApprovalTaskItemInput, id1: string): void {
    taskItem.id = id1;
    this.apiApprovalTaskItem
    .saveItem(taskItem, this.application.id, null)
    .subscribe(
      success => {
        this.emitDataFormChangeEvent.emit(task);
      },
      err => {
        console.warn(`PostretrofitComponent.updateTimeSpanTaskItemsOne() - ${err}`);
      }
    );
  }

  /**********************************************
   * Submission
   */

  private checkIfReadyForSubmission(changes: SimpleChanges): void {
    if (changes.application.previousValue !== undefined &&
        changes.application.currentValue.contractor.id !== changes.application.previousValue.contractor.id &&
        this.applicationPayment.pafTypeCode === 700000001) {
      this.pendingPafUpdate = true;
      this.updatePaymentAuthorization();
    } else if (this.evalIfReadyForSubmission()) {
      this.onEmitSubmitApplication(true);
    }
  }

  private evalIfReadyForSubmission(): boolean {
    let itemsCount = 0, itemsApprovedOrSubmitted = 0;
    let formsCompleted = false;
    let hasReceipts = false;

    if (this.pendingPafUpdate) {
      return false;
    }

    if (this.application.eventApplicationSubmitted && parseInt(this.application.submissionRejection?.toString(), 10) === 700000000) {
      return false;
    }

    if (this.isContractor() && this.application.contractorPermissionsCode === 700000000) {
      return false;
    }

    if ((this.application.contractorTypeCode === 700000000 &&
        (this.application._Ebb_ContractorId && this.application._Ebb_ContractorId.length > 0) &&
        (this.application._Ebb_ContractorId !== this.application._Ebb_OwnerId)) ||
        (this.application.contractorTypeCode === 700000001) ) {
      itemsCount++;
      itemsApprovedOrSubmitted++;
    } else {
      itemsCount++;
    }

    this.application.approvalTasks.forEach(task => {
      if (task.stageCode === this.application.stageCode) {
        task.approvalTaskItems.forEach(item => {
            if (item.statusCode === 700000001 || item.statusCode === 700000003 ||
               (this.application.eventApplicationSubmitted && item.submissionReject == null)) {
              itemsCount++;
              itemsApprovedOrSubmitted++;
            } else {
              itemsCount++;
            }
        });
      }
    });

    // check if data for forms have been submitted
    ( this.application.retrofitConstructionStartDate &&
      (this.application.inspectorFullname && this.application.inspectorFullname.length > 0) &&
      (this.application.retrofitType && this.application.retrofitType >= 700000000) )
      ? formsCompleted = true
      : formsCompleted = false;

    // check if receipts have been submitted
    ( this.taskReceipts.approvalTaskItems && this.taskReceipts.approvalTaskItems.length > 0 )
      ? hasReceipts = true
      : hasReceipts = false;

    if ((itemsCount === itemsApprovedOrSubmitted) &&
         formsCompleted &&
         hasReceipts &&
         this.application.itemsRejectedRollup <= 0) {
      return true;
    } else {
      return false;
    }
 }

  /*
  NOTE: An application migrated to post-retrofit has cea_submissionRejected === 700000000.
  Once an application is submitted, any rejections will set cea_submittion_rejection === 700000001.
  Thus, when eventPreliminaryReview is FALSE then submissionRejection must be 700000000.
  Then, when eventPreliminaryReivew is TRUE thes submissionReject must be equal to 700000001.
  The following articulates the logic below.
  */
  public canAddPermitInfo() : Boolean {
    return this.showAddAnother &&
    ((this.application.eventApplicationSubmitted === false && this.application.submissionRejection === 700000000) ||
    (this.application.eventApplicationSubmitted === true && this.application.submissionRejection === 700000001));

  }

  /**********************************************
   * Emit
   */

  public onEmitContractorUpdate(input: IApplicationInput) {
    this.getContact(input._Ebb_ContractorId, 700000001);
    this.emitEventContractorChange.emit(input);
  }

  public onEmitFormUpload(task) {
    const index = this.application.approvalTasks.findIndex(i => i.id === task.id);
  }

  public onEmitFileUploadEvent(task: IApprovalTask) {
    this.emitFileChangeEvent.emit(task);
  }

  public onEmitDataFormUpdate(task: IApprovalTask) {
    this.emitDataFormChangeEvent.emit(task);
  }

  public onEmitTimeSpanFormUpdate(task: IApprovalTask) {
    this.updateTimeSpanTaskItems(task);
  }

  public onEmitSubmitApplication(submit: boolean) {
    this.emitSubmitApplication.emit({ stageCode: this.stageCode, submit: submit} as IApplicationSubmitInput);
  }

  /**********************************************
   * Expansion Panel
   */
  private loadApprovalTaskData(): void {
    const approvalTaskList = this.application.approvalTasks.filter((task: IApprovalTask) =>
      ((task.stageCode === 700000001) !== false)
    );
    // 700000000: Permit; 700000001: House; 700000002: CrawlSpace;
    // 700000003: Heater; 700000004: Receipt; 700000005: Payment;
    approvalTaskList.forEach(task => {
      switch(parseInt(task.uiTabName,10)) {
        case 700000000:
          this.taskPermitSignoff = task;
          break;
        case 700000001:
            this.taskHousePhotos = task;
            this.programHasHousePhotos = true;
            break;
        case 700000002:
          this.taskCrawlspacePhotos = task;
          break;
        case 700000003:
          this.taskHeaterPhotos = task;
          break;
        case 700000004:
          this.taskReceipts = task;
          break;
        case 700000005:
          this.taskPaymentAuthorization = task;
          break;
      }
    });
  }

  private focusApprovalTask(initialLoad:boolean): void {
    const isMobile = this.deviceService.isMobile();
    if (this.taskPermitSignoff.statusCode === 700000000 ||
        this.taskPermitSignoff.statusCode === 700000002 ||
        !this.application.inspectorFullname) {
      //mobile will initially start all closed
      if (isMobile && initialLoad) {
        this.setApprovalTask(-1);
      } else {
        this.setApprovalTask(0);
      }
      return;
    }
    if ((this.taskHousePhotos && this.taskHousePhotos.approvalTaskItems.length > 0) &&
        (this.taskHousePhotos.statusCode === 700000000 ||
          this.taskHousePhotos.statusCode === 700000002)) {
      this.setApprovalTask(1);
      return;
    }
    if (this.taskHeaterPhotos.statusCode === 700000000 ||
        this.taskHeaterPhotos.statusCode === 700000002) {
      this.setApprovalTask(2);
      return;
    }
    if (this.taskCrawlspacePhotos.statusCode === 700000000 ||
        this.taskCrawlspacePhotos.statusCode === 700000002) {
      this.setApprovalTask(3);
      return;
    }
    if (this.taskReceipts.statusCode === 700000000 ||
        this.taskReceipts.statusCode === 700000002 ||
        this.application.retrofitType === null) {
      this.setApprovalTask(4);
      return;
    }
    if (this.taskPaymentAuthorization &&
        (this.taskPaymentAuthorization.statusCode === 700000000 ||
          this.taskPaymentAuthorization.statusCode === 700000002)) {
      this.setApprovalTask(5);
      return;
    }
    this.setApprovalTask(-1);
  }

  public loadTaskStatusIconHtml(type: string, status: number) : string {
    let iconName = 'fa-solid fa-square-1 fa-sm';
    var checkbox ='fa-solid fa-square-check fa-sm';
    var warning ='fa-solid fa-triangle-exclamation fa-sm';
   
    switch (status) {
      case 700000000:
        switch (type) {
          case 'permit':
            iconName = 'fa-solid fa-square-1 fa-sm';
            break;
          case 'house':
            iconName = 'fa-solid fa-square-2 fa-sm';
            break;
          case 'heater':
            
            (this.application.programType !== 700000002 && this.application.programType !== 700000004)
            ? iconName = 'fa-solid fa-square-2 fa-sm'
            : iconName = 'fa-solid fa-square-3 fa-sm';
          
            break;
          case 'crawlspace':
            (this.application.programType !== 700000002 && this.application.programType !== 700000004)
            ? iconName = 'fa-solid fa-square-3 fa-sm'
            : iconName = 'fa-solid fa-square-4 fa-sm'
            break;
          case 'receipt':
            (this.application.programType !== 700000002 && this.application.programType !== 700000004)
            ? iconName = 'fa-solid fa-square-4 fa-sm'
            : iconName = 'fa-solid fa-square-5 fa-sm'
            break;
          case 'payment':
            (this.application.programType !== 700000002 && this.application.programType !== 700000004)
            ? iconName = 'fa-solid fa-square-5 fa-sm'
            : iconName = 'fa-solid fa-square-6 fa-sm'
            break;
        }

        break;
      case 700000001:
        iconName = checkbox;
        break;
      case 700000002:
        iconName = warning;
        break;
      case 700000003:
        iconName = checkbox;
        if (type === 'permit') {
          if (this.application.retrofitConstructionNumberOfDays <= 0)
            iconName = 'fa-solid fa-square-1 fa-sm';
        }
        if (type === 'receipt') {
          if (this.application.retrofitType === null) {
            (this.application.programType !== 700000002 && this.application.programType !== 700000004)
            ? iconName = 'fa-solid fa-square-4 fa-sm'
            : iconName = 'fa-solid fa-square-5 fa-sm'
          }
        }
        break;
    }
    return "<i class='"+iconName+"'/>";
  }

  public loadTaskStatusValue(type: string, status: number) : string {
    let statusDisplay = '';
    switch (status) {
      case 700000000:
        statusDisplay = 'Waiting for information';
        break;
      case 700000001:
        statusDisplay = 'Approved';
        break;
      case 700000002:
        statusDisplay = 'Action required';
        break;
      case 700000003:
        if (this.application.eventApplicationSubmitted) {
          statusDisplay = 'Under Review (In Process)';
        } else {
          statusDisplay = 'Updated';
        }
        if (type === 'permit') {
          (this.application.retrofitConstructionNumberOfDays <= 0)
            ? statusDisplay = 'Waiting for information'
            : this.waitingForPermitInfo = false;
        }
        if (type === 'receipt') {
          (this.application.retrofitType === null)
            ? statusDisplay = 'Waiting for information'
            : this.waitingForReceiptInfo = false;
        }
        break;
    }
    return statusDisplay;
  }

  public setApprovalTask(index: number) {
    this.viewApprovalTask = index;
    switch (index)
    {
      case 0: this.apiHelp.setCurrentHelpTopicValue('Construction');
              break;
      case 1: this.apiHelp.setCurrentHelpTopicValue('Permit');
              break;
      case 2:
      case 3: this.apiHelp.setCurrentHelpTopicValue('Photos');
              break;
      case 4: this.apiHelp.setCurrentHelpTopicValue('Receipts');
      break;
      case 5: this.apiHelp.setCurrentHelpTopicValue('Payment');
      break;
    }
  }

  public nextApprovalTask() {
    (this.programHasHousePhotos && this.viewApprovalTask === 0)
      ? this.viewApprovalTask++
      : this.viewApprovalTask = this.viewApprovalTask + 2;
  }

  public prevApprovalTask() {
    (this.programHasHousePhotos && this.viewApprovalTask === 2)
    ? this.viewApprovalTask--
    : this.viewApprovalTask = this.viewApprovalTask - 2;
  }

  /**********************************************
   * Help
   */
  public onClickShowHelp(item: IHelp): void {
    this.infoSheet.open(AppSheetHelpComponent, { data: item });
  }

  public helpByTopic(topic: string) {
    if(topic =="payment"){
      var helptopic= this.listHelp.filter(i => i.topicCodeOptionSet.toLowerCase() === topic.toLowerCase());
      if(this.application.programType == 700000003)
      {
        helptopic = helptopic.filter(x=>x.name.toLowerCase()!=="aboutpaymentauthorization");
      }else{
        helptopic = helptopic.filter(x=>x.name.toLowerCase()!=="aboutpaymentauthorizationess");
      }
      return helptopic;
    }
    return this.listHelp.filter(i => i.topicCodeOptionSet.toLowerCase() === topic.toLowerCase());
  }

  /*******************************************
   * Add Permit File
   */
  public onPermitAddChange(event: any) : void {
    if(event.value) {
      this.waitingForPermitInfo = true;
      this.showAddAnother = false;
      this.addPermitFileEvent(event.value);
    }
  }

  public addPermitFileEvent(permitType: string): void {
    const dialogUploadDataItem: DialogUploadData = {} as DialogUploadData;
    dialogUploadDataItem.attachmentName = permitType;

    const dialogRef = this.dialogUpload.open(DialogUploadComponent, {
      width: '350px',
      data: dialogUploadDataItem
    });

    dialogRef.afterClosed().subscribe(result => {
      let taskId: string;
      if (result && result.uploadFileName.length > 0) {
        this.waitingForPermitInfo = true;
        this.progressSaveOptionalPermitDoc = true;
         const fileName = result.uploadFileName.replace(/[;,/?:@&=+$]/g, '');
        blobToBase64String(result.uploadFile)
          .then(base64string => {
            const fileString64 = base64string;
            const approvalTaskItem: IApprovalTaskItemInput = {} as IApprovalTaskItemInput;
            approvalTaskItem.typeCode = 700000000;
            approvalTaskItem.payloadTypeCode = 700000000;
            approvalTaskItem.statusCode = 700000003;
            approvalTaskItem.allowRecordCreation = true;
            approvalTaskItem.payloadName = fileName;
            taskId = this.taskPermitSignoff.id;
            approvalTaskItem.name = permitType;
            if (this.isContractor()) {
              approvalTaskItem.createdByType = 700000001;
            }
            if (this.isHomeowner()) {
              approvalTaskItem.createdByType = 700000000;
            }

            this.apiApprovalTaskItem
              .saveItem(approvalTaskItem, this.application.id, taskId)
              .subscribe(data => {
                const newItem = data as IApprovalTaskItem;
                this.taskPermitSignoff.approvalTaskItems.push(newItem);
                const indexItem = this.taskPermitSignoff.approvalTaskItems.findIndex(
                  i => i.id === data.id
                );
                this.taskPermitSignoff.approvalTaskItems[indexItem] = data as IApprovalTaskItem;
                taskId = this.taskPermitSignoff.approvalTaskItems[indexItem].id;
                const annotationInput: IAnnotationInput = {
                  id: null,
                  _Objectid_Value: this.taskPermitSignoff.approvalTaskItems[indexItem].id,
                  objectTypeCode: 'cea_approvaltaskitem',
                  fileName: fileName,
                  fileSize: result.uploadFile.size,
                  mimeType: result.uploadFile.type,
                  subject: fileName,
                  noteText: `${result.permitType}`,
                  documentBody: fileString64
                };

                this.apiAnnotation
                  .saveAnnotation(annotationInput)
                  .subscribe(data => {
                    this.progressSaveOptionalPermitDoc = false;
                    const newPayload = data.id;
                    this.taskPermitSignoff.approvalTaskItems[indexItem].payload = newPayload;
                    this.resetAddPermit();
                    this.emitFileChangeEvent.emit(this.taskPermitSignoff);
                    this.refreshData(false);
                  });
              });
          })
          .catch(err => {
            console.warn(`Unable to convert permit file`);
            this.resetAddPermit();
          });
      }
      else {
        this.resetAddPermit();
      }
    });
  }

  private resetAddPermit() : void {
    this.addPermitInfo.get('permitType').setValue(null);
    this.waitingForPermitInfo = false;
    this.showAddAnother = true;
  }

  /***     User Convenience Methods */
  public isHomeowner() : boolean {
    return this.authenticationService.isHomeowner(this.currentUser);
  }

  public isContractor(): boolean {
    return this.authenticationService.isContractor(this.currentUser);
  }
}
